import React, { useState } from 'react';
import {
  Button,
  Flex,
  VStack,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import Opcao1 from './voz';
import Opcao2 from './email';
import Opcao3 from './whatsapp';
import { PhoneIcon, EmailIcon } from '@chakra-ui/icons'; // Ícones do Chakra UI
import { FaWhatsapp } from 'react-icons/fa'; // Ícone de WhatsApp

function RepositoriesView() {
  const [activeTab, setActiveTab] = useState('opcao1');

  const renderContent = () => {
    switch (activeTab) {
      case 'opcao1':
        return <Opcao1 />;
      case 'opcao2':
        return <Opcao2 />;
      case 'opcao3':
        return <Opcao3 />;
      default:
        return null;
    }
  };

  const bg = useColorModeValue('gray.50', 'gray.800');

  return (
    <Flex direction="column" height="100%" width="100%" bg={bg} p={4}>
      <VStack spacing={4} align="stretch">
        {/* Botões de Abas reposicionados à esquerda */}
        <Flex justify="flex-start" mb={4} wrap="wrap">
          <Button
            colorScheme="blue"
            variant="solid"
            onClick={() => setActiveTab('opcao1')}
            mr={2}
            mb={{ base: 2, md: 0 }}
            bg="blue.500" // Cor azul fixa para Voz
            color="white"
            leftIcon={<PhoneIcon />} // Ícone de voz
          >
            Voz
          </Button>
          {/* <Button
            colorScheme="yellow"
            variant="solid"
            onClick={() => setActiveTab('opcao2')}
            mr={2}
            mb={{ base: 2, md: 0 }}
            bg="yellow.500" // Cor amarela fixa para E-mail
            color="white"
            leftIcon={<EmailIcon />} // Ícone de e-mail
          >
            E-mail
          </Button>
          <Button
            colorScheme="green"
            variant="solid"
            onClick={() => setActiveTab('opcao3')}
            mr={2}
            mb={{ base: 2, md: 0 }}
            bg="green.500" // Cor verde fixa para WhatsApp
            color="white"
            leftIcon={<FaWhatsapp />} // Ícone de WhatsApp
          >
            Whatsapp
          </Button> */}
        </Flex>

        {/* Área de Conteúdo */}
        <Box
          borderWidth="1px"
          borderRadius="lg"
          p={4}
          bg={useColorModeValue('white', 'gray.700')}
          boxShadow="md"
        >
          {renderContent()}
        </Box>
      </VStack>
    </Flex>
  );
}

export default RepositoriesView;
